module.exports = __webpack_public_path__ + "static/img/i3.f6b50168.png";